import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=c31261d2&scoped=true&"
import script from "./RightPanel.vue?vue&type=script&lang=ts&"
export * from "./RightPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31261d2",
  null
  
)

export default component.exports